var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"didi",attrs:{"id":"app"}},[_c('div',{staticClass:"bg"}),_c('main',[_c('div',{staticClass:"content",attrs:{"id":"main-content"}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }